import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { UiRouterResolverFactory } from '@client/app/shared/ui-router/ui-router-resolver-factory';
import { Component } from '@angular/core';
import { BrokenLinksIndexComponent } from '@client/app/pages/qa/broken-links/links/broken-links-index.component';
import { BrokenImagesIndexComponent } from '@client/app/pages/qa/broken-links/images/broken-images-index.component';
import { BrokenPagesIndexComponent } from '@client/app/pages/qa/broken-links/pages/broken-pages-index.component';
import { BrokenSitemapIndexComponent } from '@client/app/pages/qa/broken-links/sitemap/broken-sitemap-index.component';

@Component({
    selector: 'base-qa-broken',
    template: `<ui-view name="content"></ui-view>`,
    standalone: true,
    imports: [UIRouterModule],
})
class BaseQABrokenComponent {}

export const QA_BROKEN_LINKS_STATES: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.domain.qa.broken',
        url: '/broken',
        abstract: true,
        views: {
            'content@base.customer.domain.qa': {
                component: BaseQABrokenComponent,
            },
        },
        data: {
            sidebar: 'quality',
        },
        resolve: UiRouterResolverFactory.createActiveFeatureStateResolver({
            token: 'hasAccessQualityFeatures',
            pureFeatures: ['qa_links'],
        }),
    },
    {
        name: 'base.customer.domain.qa.broken.links',
        url: '/links',
        views: {
            'content@base.customer.domain.qa.broken': {
                component: BrokenLinksIndexComponent,
            },
        },
    },
    {
        name: 'base.customer.domain.qa.broken.images',
        url: '/images',
        views: {
            'content@base.customer.domain.qa.broken': {
                component: BrokenImagesIndexComponent,
            },
        },
    },
    {
        name: 'base.customer.domain.qa.broken.pages',
        url: '/pages',
        views: {
            'content@base.customer.domain.qa.broken': {
                component: BrokenPagesIndexComponent,
            },
        },
    },
    {
        name: 'base.customer.domain.qa.broken.sitemap',
        url: '/sitemap',
        views: {
            'content@base.customer.domain.qa.broken': {
                component: BrokenSitemapIndexComponent,
            },
        },
    },
];
